import { useState } from "react";
import { PackageVersion } from "@/features/private-room/bookings/layouts/booking-create-page/booking-create-page.types";
import { apiWobaBackend } from "@/services/api-woba-backend";
import { format, parse } from "date-fns";
import {
  GetPackageDetailsResponse,
  SelectedPackage,
} from "./use-get-package.types";
import { formatInTimeZone } from "date-fns-tz";

export const useGetPackages = () => {
  const [activeCycle, setActiveCycle] = useState<PackageVersion>();
  const [creditAmount, setCreditAmount] = useState(0);
  const [creditsConsumption, setCreditsConsumption] = useState(0);
  const [remainingCredits, setRemainingCredits] = useState(0);
  const [packageDetails, setPackageDetails] = useState<
    SelectedPackage & { startDate: string; endDate: string }
  >();
  const [activeUnitPrice, setActiveUnitPrice] = useState<number>();

  const getActiveCycle = async (
    date: string,
    packageId: number,
    companyId: number,
    allowPastDates: boolean = true,
  ) => {
    if (!allowPastDates) {
      const today = format(new Date(), "yyyy-MM-dd");
      const effectiveStartDate = date >= today ? date : today;
      date = effectiveStartDate;
    }

    const parsedStartDate = parse(date, "yyyy-MM-dd", new Date());

    const response: { data: GetPackageDetailsResponse } =
      await apiWobaBackend.get(
        `/companies/${companyId}/packages/${packageId}?active_cycle_at=${format(parsedStartDate, "yyyy-MM-dd")}`,
      );

    const activeCycle = response.data.activeCycle
      ? response.data.activeCycle
      : undefined;

    setActiveCycle(activeCycle);

    if (activeCycle) {
      const creditAmount =
        activeCycle.credits.amount +
        activeCycle.anticipatedCreditsReceived -
        activeCycle.anticipatedCredits;
      const creditsConsumption =
        activeCycle.credits.consumption[2] + activeCycle.credits.consumption[6];
      const remainingCredits = creditAmount - creditsConsumption;

      setCreditAmount(creditAmount);
      setCreditsConsumption(creditsConsumption);
      setRemainingCredits(remainingCredits);
      setActiveUnitPrice(activeCycle.credits.unitPrice);
    }
  };

  const getPackageDetails = async (packageId: number, companyId: number) => {
    const response: { data: GetPackageDetailsResponse } =
      await apiWobaBackend.get(`/companies/${companyId}/packages/${packageId}`);

    const startDate = formatInTimeZone(
      response.data.cycles[0].startDate,
      "UTC",
      "dd/MM/yyyy",
    );
    const endDate = formatInTimeZone(
      response.data.cycles[response.data.cycles.length - 1].endDate,
      "UTC",
      "dd/MM/yyyy",
    );

    setPackageDetails({
      ...response.data,
      name: `Pacote ID = ${packageId}`,
      versions: response.data.cycles,
      startDate,
      endDate,
      contractId: response.data.contractId,
    });
  };

  return {
    getActiveCycle,
    activeCycle,
    creditAmount,
    creditsConsumption,
    remainingCredits,
    getPackageDetails,
    packageDetails,
    activeUnitPrice,
  };
};
